// Slick Carousel
import Glide from "@glidejs/glide";

class ThreeSlidesTextCarousel {
  constructor() {
    // element that will be wrapped
    const carousel = document.querySelector(".carousel-three-slides-text");

    if (carousel) {
      const carouselTrack = document.querySelector(
        ".carousel-three-slides-text .wp-block-group"
      );
      const carouselSlides = carouselTrack.querySelector(
        ".carousel-three-slides-text .wp-block-group .wp-block-columns"
      );
      const carouselIndividualSlide = carouselTrack.querySelectorAll(
        ".carousel-three-slides-text .wp-block-group .wp-block-columns .wp-block-column"
      );

      // Add Glide classes
      carouselTrack.classList.add("glide__track");
      carouselTrack.dataset.glideEl = "track";
      carouselSlides.classList.add("glide__slides");
      carouselIndividualSlide.forEach((item) => {
        item.classList.add("glide__slide");
      });

    // Disable hover padding for multi-line h2 elements
    carouselIndividualSlide.forEach((item) => {
      const heading = item.querySelector("h2");
      if (heading) {
        const style = getComputedStyle(heading);
        const lineHeight = parseFloat(style.lineHeight);
        // If heading width exceeds 270px
        if (heading.getBoundingClientRect().width > 270) {
          heading.classList.add("no-hover-padding");
        }
      }
    });

      // Tweak styles
      carousel.style.overflow = "hidden";
      carouselSlides.style.flexWrap = "nowrap";

      // Add arrows
      carousel.insertAdjacentHTML(
        "beforeend",
        `<div class="glide__arrows" data-glide-el="controls">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fa-solid fa-circle-chevron-left"></i></button>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fa-solid fa-circle-chevron-right"></i></button>
        </div>`
      );

      // Mount carousel
      var threeSlideGlide = new Glide(".carousel-three-slides-text", {
        type: "carousel",
        perView: 3,
        breakpoints: {
          781: { perView: 2 },
          600: { perView: 1 },
        },
        autoplay: 3000,
      }).mount();
    }
  }
}

export default ThreeSlidesTextCarousel;
